module.exports = __webpack_public_path__ + "img/banner_healthy_2.c70b1512.png";